import { render } from "./CardDesign.vue?vue&type=template&id=332212e1"
import script from "./CardDesign.vue?vue&type=script&lang=js"
export * from "./CardDesign.vue?vue&type=script&lang=js"

import "./CardDesign.vue?vue&type=style&index=0&id=332212e1&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__